import { isCopilotFeatureEnabled } from 'owa-copilot-settings-utils';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import type { MailboxInfo } from 'owa-client-types';

export default function isCopilotChatEnabled(
    mailboxInfo?: MailboxInfo,
    shouldIgnoreUserPreferences?: boolean
): boolean | undefined {
    return isCopilotFeatureEnabled(
        'Chat',
        mailboxInfo ?? getModuleContextMailboxInfo(),
        true /* skipLanguageCheck */,
        shouldIgnoreUserPreferences
    );
}
